<template>
  <v-container>
        <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>
        
    <v-card-title>
  {{$t('simulacion.barridos.titulo')}} {{ id }}

  <v-tooltip location="top" width="300px" variant="outlined">
    <template v-slot:activator="{ props }">
      <v-chip
        color="main"
        class="ml-2"
        size="small"
        prepend-icon="mdi-information"
        v-bind="props"
      />
    </template>
    <div>
  <strong>{{ $t('simulacion.barridos.valores_iniciales') }}</strong><br>
  {{ $t('simulacion.barridos.eolica') }}:
    {{ obtenerValor('potencia_instalada_planta_eolica') }} MW
    {{ obtenerOpcionTexto('opciones_eolica') }}<br>
  {{ $t('simulacion.barridos.solar') }}:
    {{ obtenerValor('potencia_instalada_planta_solar_fotovoltaica') }} MW
    {{ obtenerOpcionTexto('opciones_solar_fotovoltaica') }}<br>
  {{ $t('simulacion.barridos.electrolizador') }}:
    {{ obtenerValor('potencia_nominal_electrolizador') }} MW
    {{ obtenerOpcionTexto('opciones_del_electrolizador') }}
</div>
  </v-tooltip>
</v-card-title>
        <br><br>

        <v-row dense>
          <!-- Eólica -->
          <v-col>
            <v-row no-gutters>
              <v-col>
                <v-combobox
                  v-model="potenciaEolica"
                  :items="potenciaEolica"
                  :label="$t('simulacion.barridos.potencia_eolica')"
                  multiple
                  density="compact"
                  clearable
                  chips
                  small-chips
                  closable-chips
                  hide-selected
                  dense
                  variant="outlined"
                  hide-details
                  :placeholder="$t('simulacion.barridos.valor_enter')"
                  @change="onComboboxChange('eolica')"
                />
              </v-col>
              <v-col cols="auto">
                <v-btn small class="ml-2 mt-1" @click="agregarValor('eolica')">{{$t('simulacion.barridos.boton_anadir')}}</v-btn>
              </v-col>
            </v-row>
            
          </v-col>

          <!-- Solar -->
          <v-col>
            <v-row no-gutters>
              
                <v-col>
                  <v-combobox
                    v-model="potenciaSolar"
                    :items="potenciaSolar"
                    :label="$t('simulacion.barridos.potencia_solar')"
                    multiple
                    clearable
                    chips
                    closable-chips
                    small-chips
                    density="compact"
                    variant="outlined"
                    hide-selected
                    dense
                    outlined
                    hide-details
                    :placeholder="$t('simulacion.barridos.valor_enter')"
                    @change="onComboboxChange('solar')"
                  />
                </v-col>
              <v-col cols="auto">
                <v-btn small class="ml-2 mt-1" @click="agregarValor('solar')">
                  {{$t('simulacion.barridos.boton_anadir')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- Electrolizador -->
          <v-col>
            <v-row no-gutters>
                <v-col>
                  <v-combobox
                    v-model="potenciaElectrolizador"
                    :items="potenciaElectrolizador"
                    :label="$t('simulacion.barridos.potencia_elec')"
                    multiple
                    clearable
                    chips
                    small-chips
                    closable-chips
                    density="compact"
                    variant="outlined"
                    hide-selected
                    dense
                    outlined
                    hide-details
                    :placeholder="$t('simulacion.barridos.valor_enter')"
                    @change="onComboboxChange('electrolizador')"
                  />
                </v-col>
              <v-col cols="auto">
                <v-btn small class="ml-2 mt-1" @click="agregarValor('electrolizador')">
                  {{$t('simulacion.barridos.boton_anadir')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <!-- Botón Descargar -->
          <v-col cols="auto" class="d-flex align-end">
            <v-btn v-if="showDescargarIn" color="primary" @click="descargar_in()">{{$t('simulacion.barridos.boton_descargar_in')}}</v-btn>
          </v-col>

          <!-- Botón Lanzar -->
          <v-col cols="auto" class="d-flex align-end">
            <v-btn color="primary" @click="lanzar_barrido()">{{$t('simulacion.barridos.boton_lanzar')}}</v-btn>
          </v-col>
        </v-row>

        

        <ComponenteSimulacionesHijas :id="id" @ver-resultado="handleVerResultado" :key="actualizar_componente_simulaciones_hijas"/>
        <!--<ComponenteSimulacion v-if="id_simulacion_hija !== null" :id="id_simulacion_hija" esHijo="1" :key="actualizar_componente_simulacion_hija"/>-->




  </v-container>
</template>

<script>

import ComponenteSimulacionesHijas from './ComponenteSimulacionesHijas.vue';
//import ComponenteSimulacion from './ComponenteSimulacion.vue';
import ComponenteLoading from './ComponenteLoading.vue';

import JSZip from 'jszip';
import axios from 'axios';
import store from '../store';
import Swal from "sweetalert2";
import lottie from "lottie-web";


export default {

    props: {
        datos_modelo: {
            type: Object,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },     
        resultado_variables: {
      type: Object,
      required: true,
    },    
    },


  name: "ComponenteBarridosVuetify",

  components: { 
      ComponenteSimulacionesHijas,      
      //ComponenteSimulacion,
      ComponenteLoading,
  },

  data() {
    return {
      potenciaEolica: [],
      nuevoValorEolica: '',
      potenciaSolar: [],
      nuevoValorSolar: '',
      potenciaElectrolizador: [],
      nuevoValorElectrolizador: '',
      eolicaInput: "",
      solarInput: "",
      electrolizadorInput: "",
      loading:false,
      mensaje_loading:"",
      id_simulacion_hija: null,
      esHijo: true,
      actualizar_componente_simulaciones_hijas: null,
      actualizar_componente_simulacion_hija: null,
      mostrar_boton_descargar_in: false,

    };
  },

  


  methods: {
   
obtenerValor(variableNombre) {
  for (const grupo of this.resultado_variables) {
    const encontrado = grupo.data.find((item) => item.variable === variableNombre);
    if (encontrado) return encontrado.value;
  }
  return 'N/D';
},
obtenerOpcionTexto(variableNombre) {
  const traducciones = {
    // Eólica
    'Sin planta eólica': 'Sin planta eólica',
    'Planta eólica fija': 'Fija',
    'Optimizar planta eólica': 'Optimizada',

    // Solar
    'Sin planta solar fotovoltaica': 'Sin planta solar',
    'Planta solar fotovoltaica fija': 'Fija',
    'Optimizar planta solar fotovoltaica': 'Optimizada',

    // Electrolizador
    'Electrolizador fijo': 'Fijo',
    'Optimizar el electrolizador': 'Optimizado'
  };

  for (const grupo of this.resultado_variables) {
    const encontrado = grupo.data.find((item) => item.variable === variableNombre);
    if (encontrado) {
      return traducciones[encontrado.value] || encontrado.value;
    }
  }
  return 'Desconocido';
},
    handleVerResultado(id) {      
      alert("test")
      this.id_simulacion_hija = id;
      this.actualizar_componente_simulacion_hija = Date.now();
      /*
      this.$nextTick(() => {
        this.actualizar_componente_simulacion_hija = Date.now();
      });
      */

    },

    parseInput(input) {
      return input
        .split(",")
        .map((val) => parseFloat(val.trim()))
        .filter((val) => !isNaN(val));
    },

    updateList(type) {
      if (type === "eolica") {
        this.potenciaEolica = this.parseInput(this.eolicaInput);
        /*
        if (this.potenciaEolica.length > 0) {
          this.potenciaSolar = [];
          this.potenciaelectrolizador = [];
          this.solarInput = "";
          this.electrolizadorInput = "";
        }
        */
      } else if (type === "solar") {
        this.potenciaSolar = this.parseInput(this.solarInput);
        /*
        if (this.potenciaSolar.length > 0) {
          this.potenciaEolica = [];
          this.potenciaelectrolizador = [];
          this.eolicaInput = "";
          this.electrolizadorInput = "";
        }
        */
      } else if (type === "electrolizador") {
        this.potenciaElectrolizador = this.parseInput(this.electrolizadorInput);
        /*
        if (this.potenciaelectrolizador.length > 0) {
          this.potenciaEolica = [];
          this.potenciaSolar = [];
          this.eolicaInput = "";
          this.solarInput = "";
        }
        */
      }
    },


    exportar_data() {
        
        // Descarga datos_modelo como JSON
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.datos_modelo, null, 2));
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", "datos_modelo.json");
        document.body.appendChild(downloadAnchorNode); // Necesario para Firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();

        
    },


    async lanzar_barrido() {


      let datos_agregados = JSON.parse(JSON.stringify(this.datos_modelo));
      datos_agregados['id_padre'] = this.id;
      datos_agregados['barridos'] = {
        eolica: this.potenciaEolica,
        pv: this.potenciaSolar,
        electrolizador: this.potenciaElectrolizador
      };

      // Aquí colocas el console.log
      console.log("Sensibilidades a enviar:", {
        eolica: this.potenciaEolica,
        solar: this.potenciaSolar,
        electrolizador: this.potenciaElectrolizador
      });

      try {
        

        this.errorMessage = null;
                
        try {
          const result = await Swal.fire({
            title: this.$t('mensajes.estas_seguro'),
            html: `
              <div style="text-align: center;">
                <p style="margin-bottom: 20px;"> ` + this.$t('mensajes.lanzar_simulacion') +
                `</p> <!-- Mensaje personalizado -->
                <div 
                  id="lottie-container" 
                  style="
                    width: 250px; 
                    height: 250px; 
                    margin: auto; 
                    overflow: hidden;">
                </div>
              </div>
            `,            
            //icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t('comun.boton_ok'),
            cancelButtonText: this.$t('comun.boton_cancelar'),
            didOpen: () => {
              // Renderizar la animación Lottie
              lottie.loadAnimation({
                container: document.getElementById("lottie-container"), // ID del contenedor
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: "/cohete-preparado.json", // Ruta del archivo JSON
              });
            },            
          });

          if (result.isConfirmed) {
            this.loading = true;

            // Crear un archivo ZIP con JSZip
            const zip = new JSZip();
            zip.file("data.json", JSON.stringify(datos_agregados));

            // Generar el archivo ZIP en formato blob
            const zipBlob = await zip.generateAsync({ type: "blob" });

            // Crear un objeto FormData para enviar el archivo ZIP
            const formData = new FormData();
            formData.append("file", zipBlob, "data.zip");

            // Enviar los datos al servidor            
            await axios({
              method: "post",
              url: process.env.VUE_APP_API_BASE_URL + "/api/lanzar-barrido/",
              data: formData,
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
              },
            });
                      
            this.loading = false;

            // Mostrar mensaje de éxito
            //Swal.fire(
            //  this.$t('mensajes.lanzar_simulacion_ok_titulo'), 
            //  this.$t('mensajes.lanzar_simulacion_ok_subtitulo'), 
            //  "success");

            Swal.fire({
              title: this.$t('mensajes.lanzar_simulacion_ok_titulo'),
              html: `
                <div style="text-align: center;">
                  <p style="margin-bottom: 20px;"> ` + this.$t('mensajes.lanzar_simulacion_ok_subtitulo') +
                  `</p> <!-- Mensaje personalizado -->
                  <div 
                    id="lottie-container" 
                    style="
                      width: 250px; 
                      height: 250px; 
                      margin: auto; 
                      overflow: hidden;">
                  </div>
                </div>
              `,
              confirmButtonText: this.$t('comun.boton_ok'),
              didOpen: () => {
                // Renderizar la animación Lottie
                lottie.loadAnimation({
                  container: document.getElementById("lottie-container"), // ID del contenedor
                  renderer: "svg",
                  loop: true,
                  autoplay: true,
                  path: "/cohete-lanzado.json", // Ruta del archivo JSON
                });
              },            
            });

            //Actulizar componente lista de simulaciones hijas
            this.actualizar_componente_simulaciones_hijas = Date.now();
            //Reseteo valores
            this.potenciaEolica = [];
            this.nuevoValorEolica = '';
            this.potenciaSolar = [];
            this.nuevoValorSolar = '';
            this.potenciaElectrolizador = [];
            this.nuevoValorElectrolizador = '';
            
          }
        } catch (error) {
          console.error("Error al lanzar la simulación:", error);
          this.loading = false;


          Swal.fire({
            title: this.$t('mensajes.lanzar_simulacion_error'),
            html: `
              <div style="text-align: center;">
                <p style="margin-bottom: 20px;"> ` + "" +
                `</p> <!-- Mensaje personalizado -->
                <div 
                  id="lottie-container" 
                  style="
                    width: 250px; 
                    height: 250px; 
                    margin: auto; 
                    overflow: hidden;">
                </div>
              </div>
            `,
            confirmButtonText: this.$t('comun.boton_ok'),
            didOpen: () => {
              // Renderizar la animación Lottie
              lottie.loadAnimation({
                container: document.getElementById("lottie-container"), // ID del contenedor
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: "/cohete-error.json", // Ruta del archivo JSON
              });
            },            
          });


        }
        



      } catch (error) {
        // Maneja errores de validación
        this.errorMessage = error.inner.map((e) => e.message).join(", ");
        console.error("Errores de validación:", this.errorMessage);
        Swal.fire("Errores de validacion", this.errorMessage, "error");
      }








    },


    async descargar_in() {

        console.log("Descargar_IN")
        let datos_agregados = this.datos_modelo
        datos_agregados['id_padre'] = this.id
        datos_agregados['barridos'] = {}
        datos_agregados['barridos']['eolica'] = this.potenciaEolica
        datos_agregados['barridos']['pv'] = this.potenciaSolar
        datos_agregados['barridos']['electrolizador'] = this.potenciaElectrolizador
        console.log("preLoading")
         this.loading = true;
         this.mensaje_loading = "Generando fichero IN..."

          // Crear un archivo ZIP con JSZip
          const zip = new JSZip();
          zip.file("data.json", JSON.stringify(datos_agregados));

          // Generar el archivo ZIP en formato blob
          const zipBlob = await zip.generateAsync({ type: "blob" });

          // Crear un objeto FormData para enviar el archivo ZIP
          const formData = new FormData();
          formData.append("file", zipBlob, "data.zip");
          console.log("pre Axios", this.loading , "   ", this.mensaje_loading)
          // Enviar los datos al servidor            
          await axios({
            method: "post",
            url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-in-barridos/",
            data: formData,
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + store.state.token,
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "multipart/form-data",
            },
            responseType: 'blob' // Asegura que recibimos un archivo binario
          })
            .then((response) => {    
              console.log("Recibida respuesta")
              this.loading = false;

              // Crear un enlace para descargar el archivo ZIP
              const blob = new Blob([response.data], { type: 'application/zip' });
              const url = window.URL.createObjectURL(blob);

              // Crear un elemento <a> para simular la descarga
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'IN-barridos.zip'); // Nombre del archivo
              document.body.appendChild(link);
              link.click();

              // Limpiar el DOM
              link.remove();
              window.URL.revokeObjectURL(url);
              console.log("Acabada respuesta")
            })
            .catch((error) => {
              this.loading = false;
              console.error('Error al descargar el archivo:', error);
            });     
            console.log("post Axios")               


    },

    agregarValor(tipo) {
      const valor = parseFloat(this[`nuevoValor${this.capitalizar(tipo)}`]);
      if (!isNaN(valor)) {
        this[`potencia${this.capitalizar(tipo)}`].push(valor);
        this[`nuevoValor${this.capitalizar(tipo)}`] = '';
      }
    },

    eliminarValor(tipo, index) {
      this[`potencia${this.capitalizar(tipo)}`].splice(index, 1);
    },

    capitalizar(cadena) {
      return cadena.charAt(0).toUpperCase() + cadena.slice(1);
    },

    onComboboxChange(tipo) {
  this[`potencia${this.capitalizar(tipo)}`] = this[`potencia${this.capitalizar(tipo)}`]
    .map(v => parseFloat(v))
    .filter(v => !isNaN(v));
}




  },
  computed:{
    showDescargarIn(){
    return this.$store.state.company===1;
  },
  },



  created() {

    console.log("created:")
    // Cargar configuración proporcionada desde `main.js`
    fetch('/config.json')
      .then((response) => response.json())
      .then((config) => {
        this.mostrar_boton_descargar_in = config.mostrar_boton_descargar_in;  
                
      })
      .catch((error) => {
        console.error('Error al cargar la configuración:', error);
        
      });

  },  
  mounted() {
  console.log("BARRIDOS resultado_variables", this.resultado_variables);
}





};
</script>
<style scoped>
.v-btn{
  background-color: rgb(177, 215, 255);
}
</style>
